import { forwardRef } from 'react';
import clsx from 'clsx';

export const Input = forwardRef(function Input({ className, type = 'text', ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      className={clsx(
        'flex h-10 w-full rounded-xl border border-[rgba(var(--border),0.72)] bg-[rgba(var(--panel),0.9)] px-3 py-2 text-sm text-[rgb(var(--fg))] shadow-[0_2px_6px_rgba(var(--shadow),0.06)] transition-all placeholder:text-[rgba(var(--muted),0.78)] focus-visible:outline-none focus-visible:border-[rgb(var(--ring))] focus-visible:ring-2 focus-visible:ring-[rgba(var(--ring),0.22)] focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-60 dark:border-[rgba(var(--border-strong),0.88)] dark:bg-[rgba(var(--subpanel),0.72)] dark:text-[rgb(var(--fg))] dark:placeholder:text-[rgba(var(--muted),0.82)] dark:hover:border-[rgba(var(--ring),0.62)]',
        className,
      )}
      {...props}
    />
  );
});

export default Input;
